<div class="flex flex-col w-full h-full justify-center items-center gap-2">
  @if (store.loading$()) {
    <h1 class="text-2xl font-bold">{{ 'pages.invitation.creatorInvitation.accepting' | translate }}</h1>
    <app-dots-spinner />
  } @else if (store.alreadyAccepted$()) {
    <h1 class="text-2xl font-bold">{{ 'pages.invitation.creatorInvitation.alreadyAccepted' | translate }}</h1>
    <p class="text-gray-500">{{ 'pages.invitation.creatorInvitation.alreadyAcceptedMessage' | translate }}</p>
    <app-icon src="/icons/warning.svg" [size]="80" [color]="'var(--shikenso-warning-base)'" />
    <button mat-flat-button (click)="onGoToSignInClick()">
      {{ 'pages.invitation.creatorInvitation.goToSignIn' | translate }}
    </button>
  } @else if ((store.error$() && !store.loading$()) || !validInvitationId()) {
    <h1 class="text-2xl font-bold">{{ 'pages.invitation.creatorInvitation.invalidInvitation' | translate }}</h1>
    <p class="text-gray-500">{{ 'pages.invitation.creatorInvitation.invalidInvitationMessage' | translate }}</p>
    <app-icon src="/icons/misuse-outline.svg" [size]="80" [color]="'var(--shikenso-error-base)'" />
  } @else {
    <h1 class="text-2xl font-bold">{{ 'pages.invitation.creatorInvitation.accepted' | translate }}</h1>
    <p class="text-gray-500">{{ 'pages.invitation.creatorInvitation.acceptedMessage' | translate }}</p>
    <app-icon src="/icons/circle-check.svg" [size]="80" [color]="'var(--shikenso-success-base)'" />
    <app-dots-spinner />
  }
</div>
